import { zodResolver } from "@hookform/resolvers/zod";
import SearchIcon from "@mui/icons-material/Search";
import { Grid, TextField, Typography } from "@mui/material";
import { t } from "i18next";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useCustomers } from "../../../services/customersService";
import BasicDialog from "../../base/BasicDialog";
import { ClientSearchTable } from "./ClientSearchTable";

export function SearchTopPotentialDialog(props) {
    const { data: customers } = useCustomers(
        new URLSearchParams({
            top_potential_customers: props.personId,
            customer_type: "person",
        }),
        {
            enabled: true,
        },
    );

    return (
        // @ts-ignore
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={props.title}
            maxWidth={"md"}
            showDialogActions
            titleSx={{
                pb: 0,
            }}
        >
            <Grid
                item
                sx={{
                    p: 2,
                    py: 3,
                    bgcolor: "whitesmoke",
                    mt: 2,
                    borderRadius: 2,
                }}
            >
                <ClientSearchTable
                    clientId={props.clientId}
                    sx={{
                        borderRadius: 2,
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderColor: "ButtonFace",
                    }}
                    // @ts-ignore
                    data={customers?.results || []}
                    onCustomerSelected={props.onCustomerSelected}
                />
            </Grid>
        </BasicDialog>
    );
}
